import { render, staticRenderFns } from "./ActiveTask.vue?vue&type=template&id=1630cef7&scoped=true"
import script from "./ActiveTask.vue?vue&type=script&lang=js"
export * from "./ActiveTask.vue?vue&type=script&lang=js"
import style0 from "./ActiveTask.vue?vue&type=style&index=0&id=1630cef7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1630cef7",
  null
  
)

export default component.exports